import {
    namespace,
    reducer,
    selectors,
} from './base';
import * as operations from './operations';

const updateBillingAddressAction = {
    ...operations,
    ...selectors,
};

export {
    updateBillingAddressAction,
};
export default {
    [namespace]: reducer,
};
